import gql from 'graphql-tag';
import channelInfoFragment from '../../fragments/channel/channelInfo';

export default gql`
  fragment communityChannelConnectionWithSlackSettings on Community {
    channelConnection {
      edges {
        node {
          ...channelInfo
          slackSettings {
            botLinks {
              threadCreated
            }
          }
        }
      }
    }
  }
  ${channelInfoFragment}
`;
